// src/utils/statusLabels.js
export const statusLabels = {
    pending: 'En-attente',
    paid: 'Retiré',
    cancelled: 'Annulé',
  };
  
  export const statusValues = {
    'En-attente': 'pending',
    'Retiré': 'paid',
    'Annulé': 'cancelled',
  };